<script lang="ts">
  import clsx from 'clsx';

  const { sizeClass = 'h-full w-full' }: { sizeClass?: string } = $props();
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 70 74"
  fill="currentColor"
  class={clsx(sizeClass, 'overflow-hidden align-middle')}
  transform="rotate(90)"
>
  <path
    d="M31.7341 23.8772L31.7341 46.2549L56.9935 46.2549L45.887 23.8772L31.7341 23.8772Z"
    fill="#6E7071"
    stroke="#979797"
  />
  <path
    d="M57.8002 46.2554C60.889 46.2554 63.8076 43.8467 65.9837 39.6769C68.1472 35.5313 69.5003 29.7694 69.5003 23.3777C69.5003 16.986 68.1472 11.2241 65.9837 7.0785C63.8076 2.9087 60.889 0.499999 57.8002 0.499999C54.7114 0.5 51.7928 2.9087 49.6167 7.0785C47.4532 11.2241 46.1001 16.986 46.1001 23.3777C46.1001 29.7694 47.4532 35.5313 49.6167 39.6769C51.7928 43.8467 54.7114 46.2554 57.8002 46.2554Z"
    fill="#B2B4B4"
    stroke="#979797"
  />
  <path
    d="M57.8 30.3713C58.5248 30.3713 59.3199 29.761 59.9634 28.4554C60.5912 27.1818 60.9938 25.3873 60.9938 23.3779C60.9938 21.3685 60.5912 19.5739 59.9634 18.3003C59.3199 16.9948 58.5248 16.3845 57.8 16.3845C57.0751 16.3845 56.2801 16.9948 55.6366 18.3003C55.0087 19.5739 54.6062 21.3685 54.6062 23.3779C54.6062 25.3873 55.0087 27.1818 55.6366 28.4554C56.2801 29.761 57.0751 30.3713 57.8 30.3713Z"
    fill="#6E7071"
    stroke="#979797"
  />
  <path
    d="M0.578035 23.3331L0.578045 23.3332L0.580025 23.3554L0.580025 23.3777L0.580027 73.1546L45.6955 73.1546L45.6955 23.3777C45.6955 13.7758 48.6339 7.81631 51.6142 4.25003C53.1009 2.47094 54.5906 1.29636 55.7141 0.564488C55.7477 0.542597 55.781 0.521102 55.8139 0.499998L9.56792 0.5C4.37637 3.23831 2.10387 8.84523 1.14715 13.9006C0.667816 16.4334 0.525415 18.7956 0.503258 20.5259C0.492189 21.3903 0.511151 22.0953 0.532767 22.5828C0.543573 22.8265 0.555036 23.0157 0.563727 23.1432C0.568072 23.207 0.571723 23.2553 0.574251 23.2872L0.577147 23.3228L0.577862 23.3312L0.578019 23.333L0.578035 23.3331Z"
    fill="white"
    stroke="#979797"
  />
  <circle cx="23.5" cy="53.5" r="14.25" fill="white" stroke="#979797" stroke-width="0.5" />
  <path
    d="M27.739 60.9999L26.539 57.9759H20.491L19.267 60.9999H15.427L21.883 44.9919H25.267L31.579 60.9999H27.739ZM21.571 55.1439H25.531L23.563 49.7679L21.571 55.1439Z"
    fill="#757575"
  />
  <circle cx="23.5" cy="20.5" r="14.25" fill="white" stroke="#979797" stroke-width="0.5" />
  <path
    d="M27.739 28.0001L26.539 24.9761H20.491L19.267 28.0001H15.427L21.883 11.9921H25.267L31.579 28.0001H27.739ZM21.571 22.1441H25.531L23.563 16.7681L21.571 22.1441Z"
    fill="#757575"
  />
</svg>
